namespace Core {

    //service to hold common bits required for tracking data when completing a booking.
    //two routes for us to handle booking complete from the booking form and complete after
    //coming from payment via PayPal

    type QuoteService = Quote.QuoteService;
    type TripState = Core.Trip.TripState;
    type TripType = Core.Trip.TripType;

    interface TrackingData
    {
        hotel : any;
        totalCost :number;
    }

    export class BookingCompleteTrackingService {

        constructor(
            private $q :ng.IQService,
            private abTest :any,
            private analytics :any,
            private basketStore :any,
            private criteoService :any,
            private ecommerceService :any,
            private quoteService :QuoteService,
            private trackingPixelsService :any
        ) {
        }

        trackConversion(trip :TripState,
                        refs :string[],
                        source :string,
                        userEmail :string,
                        rooms :any):ng.IPromise<void> {

            return this.basketStore.all(trip.BasketId).then(basket => {
                //dont bother running analytics code as we dont have a basket anymore!
                if (basket.f == null && basket.h == null && basket.t == null && basket.c == null &&
                    basket.a == null && basket.p == null) {
                    return;
                }
                return this.trackTotalCost(
                                    <string>trip.BasketId,
                                    basket,
                                    refs,
                                    source,
                                    userEmail,
                                    trip.TripId,
                                    trip.TripType,
                                    trip.QuoteId,
                                    rooms
                );
            });
        }

        private trackTotalCost(basketId :string,
                               basket :any,
                               refs :string[],
                               source :string,
                               userEmail :string,
                               tripId :string,
                               tripType :TripType,
                               quoteId :string | undefined,
                               rooms :any) :ng.IPromise<void> {

            return this.$q.all([
                this.basketStore.totalCostFromBasket(basket),
                this.basketStore.getBasketCurrency(basketId)
            ]).then(results => {
                const totalCost = results[0];
                const currency = results[1];

                const criteoData = {
                    ref: refs.join('|'),
                    items: {
                        hotel: basket.h,
                        flight: basket.f
                    },
                    price: totalCost
                };

                this.criteoService.enqueue(criteoData, 'bookingcomplete', tripType);

                const trackingData = {
                    TotalCost: totalCost,
                    Hotel: basket.h,
                    Flight: basket.f,
                    CarHire: basket.c,
                    Transfer: basket.t,
                    Attractions: basket.a,
                    Insurance: basket.i,
                    Parking: basket.p,
                    Marhaba: basket.m,
                    FirstBookingId: refs[0].split('/')[1],
                    Source: source
                };

                this.analytics.track('mixpanel', 'BookingComplete', trackingData);
                this.analytics.track('mixpanelPeople', 'BookingComplete', trackingData);
                this.analytics.setMixpanelEmail(userEmail);

                return this.ecommerceService.pushBasket(tripId, basket, totalCost, refs)
                    .then(() => {
                        this.trackingPixelsService.setData(refs, currency, totalCost, basket.h, rooms, tripType);

                        this.abTest.recordRevenue(totalCost);

                        const run = $.when();

                        if (TRPCONFIG.Domain.QuoteEnabled && quoteId) {
                            run.then(() => this.quoteService.linkQuote(refs, quoteId));
                        }

                        return run;
                    });
            });
        }


    }

    angular
        .module('TR')
        .service('bookingCompleteTrackingService', BookingCompleteTrackingService);
}
